const info = {
  CN: {
    home: "首页",
    case: "项目案例",
    product: "产品服务",
    about: "关于",
    address:
      "地址：深圳市南山区高新南九道西北工业大学三航科技大厦2105 电话：0755-83239076",
    Copyright: "Copyright ©2019 金马节能科技（深圳）有限公司",
    gov: "粤ICP备18079475号",
    back: "返回",
    language: "请选择语言",
  },
  EN: {
    home: "Home page",
    case: "Project Cases",
    product: "Product Services",
    about: "About",
    address:
      "Room 2105, Sanhang Science & Technology Building, Northwestern Polytechnical University, Gaoxin South 9th Road, Nanshan District, Shenzhen, China",
    Copyright: "BLEMS PTE. LTD",
    gov: "Yue ICP Bei No. 18079475",
    back: "Back",
    language: "Languages",
  },
};
export default info;



// WEBPACK FOOTER //
// ./src/language/header/index.js